import { IconButton } from '@mui/material'
import { WEastIcon } from '@weblite/icons'
import { forwardRef, ForwardedRef } from 'react'

interface Props {
  onClick: () => unknown
  color?: string
}

export const BackButton = forwardRef(function BackButton(
  { onClick, color }: Props,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <IconButton ref={ref} onClick={onClick}>
      <WEastIcon sx={{ color: color || 'neutral1000' }} />
    </IconButton>
  )
})
